module.exports = __webpack_public_path__ + "static/media/S (191).462bb2d5.jpg";